import { useUpdateMemberActivation } from 'components/IncidentConfig/hooks/useUpdateMemberActivation';

export type ActivationResponse =
  | 'accepted'
  | 'declined'
  | 'resend_24h'
  | 'resend_48h';

type ActivationParams = {
  incidentId: string;
  memberUserGuid: string;
  isActivated: boolean;
  declineNote?: string;
  activationResponse?: ActivationResponse;
  responseComment?: string;
};

export const useActivationActions = () => {
  const mutation = useUpdateMemberActivation();

  return {
    ...mutation,
    mutateAsync: ({
      incidentId,
      memberUserGuid,
      isActivated,
      declineNote,
      activationResponse,
      responseComment,
    }: ActivationParams) => {
      return mutation.mutateAsync({
        /* eslint-disable camelcase */
        incident_id: incidentId,
        member_user_guid: memberUserGuid,
        is_activated: isActivated,
        decline_note: isActivated ? undefined : declineNote,
        activation_response: activationResponse,
        response_comment: responseComment,
        /* eslint-enable camelcase */
      });
    },
  };
};
